import { useState } from 'react'
import { Option } from '../../components/common/Form/types'

export const useSearch = (
    getParams: (searchValue: string) => {
        options?: Array<Option>
        compareFn?: (option: Option) => boolean
    }
) => {
    const [searchValue, setSearchValue] = useState('')
    const {
        options: defaultOptions,
        compareFn = (option: Option) => {
            return option.label
                .toLowerCase()
                .trim()
                .includes(searchValue.toLowerCase().trim())
        },
    } = getParams(searchValue)

    const options = defaultOptions?.filter(compareFn)

    return { options: options as Option<string>[], searchValue, setSearchValue }
}
